import React, { useState } from 'react';
import { pdfjs, Document, Page } from 'react-pdf';
import HTMLFlipBook from "react-pageflip";
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

import './pdf.css';

import type { PDFDocumentProxy } from 'pdfjs-dist';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.js',
  import.meta.url,
).toString();

const options = {
  cMapUrl: 'cmaps/',
  standardFontDataUrl: 'standard_fonts/',
};

type PDFFile = string | File | null;

export default function PDF() {
  const file: PDFFile = './marine-conservation-center_case-for-support.pdf';
  const [numPages, setNumPages] = useState<number>();

  function onDocumentLoadSuccess({ numPages: nextNumPages }: PDFDocumentProxy) {
    setNumPages(nextNumPages);
  }

  type AppPageProps = {
    pagenumber: number;
  };

  const AppPage = React.forwardRef<HTMLDivElement, AppPageProps>(({ pagenumber }: AppPageProps, ref) => {
    return (
      <div ref={ref}>
        <Page key={`page_${pagenumber}`} pageNumber={pagenumber} height={548} width={710} />
      </div>
    );
  });

  return (
    <div className="PDF">
      <Document file={file} onLoadSuccess={onDocumentLoadSuccess} options={options}>
        <HTMLFlipBook height={548} showCover={true} width={710}>
          {Array.from(new Array(numPages), (el, index) => (
            <AppPage pagenumber={index + 1} />
          ))}
        </HTMLFlipBook>
      </Document>
    </div>
  );
}
